import { COLOR_PALETTE, mediaQuery } from 'constants/ui';

export const getPendingChangeOutlinedHighlightStyles = (columns, afterCustomStyles = {}) => ({
  position: 'relative',
  width: columns !== 1 ? 'fit-content' : '100%',

  '&:after': {
    position: 'absolute',
    content: '""',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    border: `1px solid ${COLOR_PALETTE.ORANGE[7]}`,
    borderRadius: '4px',

    ...afterCustomStyles,
  },
});

export const entitySideDataTableStyles = {
  gap: '44px',
  '& .titleContainer': {
    flexDirection: 'row',
  },
  '& .title': {
    fontWeight: 700,
    fontSize: '1.6rem',
  },
  '& .table-container': {
    border: 0,
    overflowX: 'unset',
    [mediaQuery.mobileAndTablet]: {
      overflowX: 'auto',
    },
  },
  '& .table-head': {
    borderTop: ({ palette }) => `1px solid ${palette.border.default || COLOR_PALETTE.GRAY[4]}`,
    borderBottom: ({ palette }) => `1px solid ${palette.border.default || COLOR_PALETTE.GRAY[4]}`,
    '& .table-cell': {
      padding: '15px',
      '&:first-of-type': {
        paddingLeft: '40px',
      },
      '&:last-child': {
        paddingRight: '40px',
      },
    },
  },
  '& .table-body': {
    '& .table-cell': {
      padding: '12px 0 0',
      '& .table-cell__content_box': {
        padding: '24px 15px',
      },
      '&:first-of-type': {
        '& .table-cell__content_box': {
          paddingLeft: '40px',
          borderRadius: '4px 0 0 4px',
          borderLeft: ({ palette }) =>
            `1px solid ${palette.border.default || COLOR_PALETTE.GRAY[4]}`,
        },
      },
      '&:last-child': {
        '& .table-cell__content_box': {
          paddingRight: '40px',
          borderRadius: '0 4px 4px 0',
          borderRight: ({ palette }) =>
            `1px solid ${palette.border.default || COLOR_PALETTE.GRAY[4]}`,
        },
      },
    },
    '& .table-row': {
      border: 0,
      '&:after': {
        top: 'calc(50% + 5px)',
      },
      '&[data-is-changed="true"]': {
        '& .table-cell__content_box': {
          borderColor: COLOR_PALETTE.ORANGE[7],
        },
      },
    },
    '& [data-cell-modified="true"]': {
      '& .table-cell__content_box': {
        backgroundColor: 'unset',
        width: 'unset',
        padding: '17px',
        borderRadius: 'unset',
        '& span': {
          padding: '7px 8px',
          borderRadius: '4px',
          backgroundColor: COLOR_PALETTE.ADDITIONAL[1],
          width: 'fit-content',
          marginLeft: '-8px',
        },
      },
    },
    '& [data-row-deleted="true"], [data-row-added="true"]': {
      backgroundColor: 'unset',
      '& .table-cell__content_box': {
        backgroundColor: COLOR_PALETTE.ADDITIONAL[1],
      },
    },
    '& [data-row-with-additional-content="true"]': {
      '& .table-cell': {
        '&:first-of-type': {
          '& .table-cell__content_box': {
            borderRadius: '4px 0 0 0',
          },
        },
        '&:last-child': {
          '& .table-cell__content_box': {
            borderRadius: '0 4px 0 0',
          },
        },
      },
    },
    '& .table-cell__content_box': {
      borderTop: ({ palette }) => `1px solid ${palette.border.default || COLOR_PALETTE.GRAY[4]}`,
      borderBottom: ({ palette }) => `1px solid ${palette.border.default || COLOR_PALETTE.GRAY[4]}`,
      padding: '24px',
      height: '72px',
    },
    '& .additional-row-content-cell': {
      padding: 0,
      border: 0,
    },
    '& .additional-row-content': {
      '&[data-is-changed="true"]': {
        '& .additional-row-content-cell-collapse': {
          borderColor: COLOR_PALETTE.ORANGE[7],
        },
      },
    },
    '& .additional-row-content-cell-collapse': {
      border: ({ palette }) => `1px solid ${palette.border.default || COLOR_PALETTE.GRAY[4]}`,
      borderRadius: '0 0 4px 4px',
      padding: '0 24px 24px',
      borderTop: 0,
    },
  },
};
